<script>
    import { onMount } from "svelte";
    import { t } from '$lib/translations';

    let showCookieBanner = false;

    onMount(() => {
        const cookieConsent = localStorage.getItem("cookies");
        if (cookieConsent !== "accepted") {
            showCookieBanner = true;
        }
    })

    const acceptCookies = () => {
        localStorage.setItem("cookies", "accepted");
        showCookieBanner = false;
    }
</script>

{#if showCookieBanner}
    <section>
        <div class="cookie-consent">
            <div class="text">{$t('cookies.description')}</div>
            <div class="close-btn">
                <button class="btn" on:click={acceptCookies}>{$t('cookies.exit')}</button>
            </div>
        </div>
    </section>
{/if}

<style lang="scss">
    section {
        margin: 0;
        position: fixed;
        width: 100%;
        bottom: 2%;
        z-index: 100;
        padding: 0 30px;
    }

    .cookie-consent {
        box-shadow: 0 0 1px 0 rgba(96, 96, 96, 0.1), 0 12px 24px -6px rgba(96, 96, 96, 0.15);
        background: #1e1e1e;
        border-radius: 10px;
        padding: 12px 16px;
        display: flex;
        gap: 20px;
        align-items: center;

        & > .text {
            color: white;
            font-weight: 300;
            font-size: 13px;
            line-height: 167%;
            width: 560px;
        }

        & > .close-btn {

            & > button {
                font-weight: 500;
                font-size: 13px;
                border-radius: 8px;
                background-color: white;
                padding: 7px 13px;
                color: black;
            }
        }
    }

    @media screen and (max-width: 760px) {
        .text {
            width: auto!important;
        }
    }

    @media screen and (max-width: 540px) {
        .cookie-consent {
            display: flex;
            flex-direction: column;
        }

        .close-btn {
            width: 100%;
        }
    }
</style>